<template>
  <el-dialog :title="title" :visible.sync="showDialog" :show-close=false width="400px" :close-on-click-modal="false">
    <div>
      <el-progress :percentage="percentage"></el-progress>
    </div>
  </el-dialog>
</template>

<script>
import {
   Dialog,Progress
} from 'element-ui';

Vue.use(Dialog);
Vue.use(Progress);

import Vue from "vue";
import GlobalData from '@/assets/js/common/GlobalData.js'

export default {
  name: "SocketIo",
  data() {
    return {
      showDialog:false,
      title:"",
      percentage:0,
    }
  },
  watch: {},
  mounted() {
    // console.log('userId is ' + localStorage.getItem("socketioUserToken"))

    //订阅指定用户消息推送
    this.sockets.subscribe(`${GlobalData.SOCKET_PROJECT_CODE}WebPointReceive_${localStorage.getItem("socketioUserToken")}`, (data) => {
      this.showDialog = true

      const dataObj = JSON.parse(data) ? JSON.parse(data) : new Object()

      //百分比
      this.percentage = dataObj.progressVal ? dataObj.progressVal : 0

      //标题
      if(dataObj.businessType == 1)
      {
        this.title = 'Bug导入'
      }
      else if(dataObj.businessType == 2)
      {
        this.title = '测试用例导入'
      }
      else if(dataObj.businessType == 3)
      {
        this.title = '任务导入'
      }
      else if(dataObj.businessType == 4)
      {
        this.title = '模块导入'
      }
      else
      {
        this.title = '导入'
      }

      //弹窗消失
      if(dataObj.progressVal >= 100)
      {
        this.showDialog = false
      }
    })

    //订阅广播
    // this.sockets.subscribe(`${GlobalData.SOCKET_PROJECT_CODE}WebBroadcastReceive`, (data) => {
    //   console.info(data)
    // })
  },
  methods: {
  },
  sockets: {
    connect() {
      console.log('socket io is connected!!')
    },
  },
  beforeDestroy() {
    //销毁订阅
    this.sockets.unsubscribe(`${GlobalData.SOCKET_PROJECT_CODE}WebPointReceive_${localStorage.getItem("socketioUserToken")}`)
    // this.sockets.unsubscribe(`${GlobalData.SOCKET_PROJECT_CODE}WebBroadcastReceive`)
  }
}
</script>

<style scoped>

</style>
